import React from "react";
import type {
  EnrichedSwarovskiProductFrontendProductAggregatedReviews,
  SwarovskiOptikLocaleFrontend,
} from "@swo/storefront";
import { FONTS } from "../../../styles/fonts";
import { PDPReviewStars } from "./PDPReviewStars";
import { css } from "@emotion/react";
import { getReviewScoreFormatter } from "./getReviewScoreFormatter";
import { ReviewsLabel } from "./ReviewsLabel";
import { ReviewTranslations } from "../reviewTranslations";

export const PDPReviewSummary: React.FC<{
  reviewsData: NonNullable<EnrichedSwarovskiProductFrontendProductAggregatedReviews>;
  locale: SwarovskiOptikLocaleFrontend;
  id: string;
  t: ReviewTranslations;
}> = ({ reviewsData: { averageRating, reviews }, locale, id, t }) => {
  const formattedAverageRating = getReviewScoreFormatter(locale).format(averageRating);

  return (
    <div className="u-mb-2 u-flex u-gap-2 u-ai-center">
      <PDPReviewStars rating={averageRating} starsTheme="dark" />

      <span>{formattedAverageRating}</span>

      <a
        href={`#${id}`}
        className="u-underline"
        css={[
          FONTS.SwarovskiFutura300,
          css`
            color: inherit;
          `,
        ]}
      >
        <ReviewsLabel reviewsCount={reviews.length} t={t} />
      </a>
    </div>
  );
};

export const StarSvg: React.FC<{ className: string }> = ({ className }) => (
  <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path
      d="M6.57377 0.934326L8.0644 5.522H12.8882L8.98565 8.35734L10.4763 12.945L6.57377 10.1097L2.67126 12.945L4.16189 8.35734L0.259379 5.522H5.08314L6.57377 0.934326Z"
      fill="currentColor"
    />
  </svg>
);

export const PartialStarSvg: React.FC<{ percentage: number; className: string }> = ({ percentage, className }) => {
  const size = 15;

  const x = -13 + 11 * percentage;

  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        className="empty-fill"
        d="M7.42623 0.934326L8.91686 5.522H13.7406L9.83812 8.35734L11.3287 12.945L7.42623 10.1097L3.52372 12.945L5.01435 8.35734L1.11184 5.522H5.93561L7.42623 0.934326Z"
      />
      <g clipPath="url(#clip0_2328_31327)">
        <path
          d="M7.42623 0.934326L8.91686 5.522H13.7406L9.83812 8.35734L11.3287 12.945L7.42623 10.1097L3.52372 12.945L5.01435 8.35734L1.11184 5.522H5.93561L7.42623 0.934326Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_2328_31327">
          <rect width={size} height={size} fill="white" transform={`translate(${x} 0)`} />
        </clipPath>
      </defs>
    </svg>
  );
};
